var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraControlIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.54 16.46L10 20L13.54 23.54L15.3 21.77L13.54 20L15.3 18.23L13.54 16.46ZM26.46 16.46L24.7 18.23L26.46 20L24.7 21.77L26.46 23.54L30 20L26.46 16.46ZM20 26.46L18.23 24.7L16.46 26.46L20 30L23.54 26.46L21.77 24.7L20 26.46ZM16.46 13.54L18.23 15.3L20 13.54L21.77 15.3L23.54 13.54L20 10L16.46 13.54Z",
    fill: "#5D6C7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraControlIcon);
export default __webpack_public_path__ + "static/media/Camera_control_icon.ae16907421d8e86059a0290f08ba55ae.svg";
export { ForwardRef as ReactComponent };